import { useEffect, useState } from 'react';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BannerSlider from '../components/home/BannerSlider';
import { getBannerSlides } from '../api/bannerSlides';
import CustomerService from '../components/home/CustomerService';
import OurPicks from '../components/home/OurPick';
import { BannerSlide } from '@/types/bannerSlides';
import BrandSection from '@/components/home/Brand';
import PromoBannerSlider from '../components/home/PromoBannerSlider';

export default function Home() {
  const { i18n } = useTranslation();
  const [slides, setSlides] = useState<BannerSlide[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const data = await getBannerSlides(i18n.language);
        setSlides(data);
      } catch (error) {
        console.error('Error fetching banner slides:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, [i18n.language]);

  return (
    <Box
      sx={{
        flexGrow: 1,
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#fff',
        flexDirection: 'column',
      }}
    >
      {/* Banner Slider */}
      <Box sx={{ width: '100%', height: 'auto', mb: 2 }}>
        {loading ? (
          <Skeleton
            variant="rounded"
            width="100%"
            height={'auto'}
            sx={{ mb: 0, borderRadius: 2 }}
          />
        ) : (
          <BannerSlider slides={slides} />
        )}
      </Box>

      {/* Promo Banner Slider */}
      <PromoBannerSlider />
      <div style={{marginBottom: '15px'}}/>
      <OurPicks />
      <div style={{marginBottom: '30px'}}/>
      <BrandSection />

      {/* Customer Service */}
      <CustomerService />
    </Box>
  );
}
